import {Tag as TagParent} from "antd";
import { forwardRef } from 'react';
import cn from "classnames/bind";

export const Tag = forwardRef(function Tag(props, ref) {
    const {style = {}, className,  ...rest} = props

    return (
        <>
            <TagParent
                className={cn(className, 'ant_tag')}
                ref={ref}
                bordered={false}
                style={{
                    height: 32,
                    marginInlineEnd: 0,
                    ...style,
                }}
                {...rest}
            />
        </>
    );
});
